import { render, staticRenderFns } from "./addKeyWord.vue?vue&type=template&id=da651d2a&scoped=true"
import script from "./addKeyWord.vue?vue&type=script&lang=js"
export * from "./addKeyWord.vue?vue&type=script&lang=js"
import style0 from "./addKeyWord.vue?vue&type=style&index=0&id=da651d2a&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "da651d2a",
  null
  
)

export default component.exports